import Vue from "vue";
import router from "../../router";

const orders = {
  namespaced: true,
  state: {
    items: [],
  },
  mutations: {
    setOrders(state, payload) {
      state.items = payload;
      router.push({ name: "home" });
    },
    makeProductAssembled(state, product) {
      let existsProduct = this.getters["orders/getProduct"](product);

      if (existsProduct) {
        existsProduct.assembled = product.quantity;
      }
    },
    setProductHasReplacementTrue(state, product) {
      let existsProduct = this.getters["orders/getProduct"](product);

      if (existsProduct) {
        existsProduct.hasReplacement = true;
      }
    },
  },
  actions: {
    findJoinedTasks: function (context, orders) {
      const orderNumbers = orders.map((order) => order.order_number);
      Vue.prototype.$axios
        .post("replacement_joined", { orderNumbers })
        .then((res) => {
          if (res.data.length) {
            orders.forEach((order) => {
              order.carts.forEach((cart) => {
                cart.products.forEach((product) => {
                  const orderTasks = res.data.filter(
                    (resOrder) =>
                      resOrder.order.order_number === order.order_number
                  );
                  // if (orderTasks && orderTasks.length) {
                  orderTasks.forEach((task) => {
                    task.replacements.forEach((replacement) => {
                      if (
                        parseInt(product.article) ===
                          parseInt(replacement.article_from) &&
                        product.size === replacement.size_from &&
                        parseInt(cart.number) ===
                          parseInt(replacement.cart_number)
                      ) {
                        product.hasReplacement = true;
                        product.replacemens.push(task.task_id);
                      }
                    });
                  });
                  // }
                });
              });
            });

            this.commit("orders/setOrders", orders);
          }
        });
    },
  },
  getters: {
    getProduct: (state) => (product) => {
      let existsProduct = null;

      state.items.forEach((stateOrder) => {
        stateOrder.carts.forEach((stateCart) => {
          stateCart.products.forEach((stateProduct) => {
            if (
              String(stateProduct.orderNumber) ===
                String(product.orderNumber) &&
              String(product.Item_ID) === String(stateProduct.Item_ID) &&
              parseInt(stateCart.number) === parseInt(product.cartNumber)
            ) {
              existsProduct = stateProduct;
            }
          });
        });
      });

      return existsProduct;
    },
    getProductForReplace: (state) => (orderId, cartNumber, article, size) => {
      const order = state.items.find((order) => order.order_id === orderId);

      if (null === order) return null;

      const cart = order.carts.find(
        (cart) => cart.number === parseInt(cartNumber)
      );

      if (null === cart) return null;

      const product = cart.products.find(
        (product) =>
          parseInt(product.article) === parseInt(article) &&
          String(product.size) === String(size)
      );

      if (null === product) return null;

      return product;
    },
    findProductForUpdate: (state) => (update) => {
      let existsProduct = null;

      state.items.forEach((stateOrder) => {
        stateOrder.carts.forEach((stateCart) => {
          stateCart.products.forEach((stateProduct) => {
            console.info(update, stateProduct);
            if (
              String(stateProduct.orderNumber) ===
                String(update.order_number) &&
              String(stateProduct.Item_ID) === String(update.Item_ID) &&
              parseInt(stateProduct.cartNumber) === parseInt(update.cart_number)
            ) {
              existsProduct = stateProduct;
            }
          });
        });
      });

      return existsProduct;
    },
  },
};

export default orders;
